import React from 'react'

import Review from '@/components/EstateForm/Review'

const ReviewPage = () => <Review />

export default ReviewPage
